import React, { useState, useEffect } from 'react'
import { Icon } from '@iconify/react';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';

const ControlTowerCards = () => {
    const { auth } = useAuth();
    const [stats, setStats] = useState({
        users_b2c: 0,
        venues_b2b: 0,
        verified_venues: 0,
        pending_verifications: 0,
        paid_subscriptions: 0,
        monthly_revenue: 0,
        revenue_today: 0
    });

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/stats/control-tower`);
                if (response.ok) {
                    const data = await response.json();
                    setStats(data);
                }
            } catch (error) {
                console.error('Failed to fetch control tower stats:', error);
            }
        };

        fetchStats();
    }, [auth]);

    return (
        <div className="row row-cols-xxxl-4 row-cols-lg-4 row-cols-md-2 row-cols-sm-2 row-cols-1 gy-4">
            {/* Total Users (B2C) */}
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-1 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Users (B2C)</p>
                                <h6 className="mb-0">{stats.users_b2c.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="gridicons:multiple-users" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Total Venues (B2B) */}
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-2 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Venues (B2B)</p>
                                <h6 className="mb-0">{stats.venues_b2b.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa-solid:store" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Verified Venues */}
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-3 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Verified Venues</p>
                                <h6 className="mb-0">{stats.verified_venues.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="mdi:check-decagram" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Pending Verifications */}
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Pending Verifications</p>
                                <h6 className="mb-0 text-warning">{stats.pending_verifications.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="mdi:clock-alert-outline" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             {/* Paid Subscriptions */}
             <div className="col">
                <div className="card shadow-none border bg-gradient-start-1 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Paid Subscriptions</p>
                                <h6 className="mb-0">{stats.paid_subscriptions.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="mdi:crown" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             {/* Monthly Revenue */}
             <div className="col">
                <div className="card shadow-none border bg-gradient-start-2 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Monthly Revenue</p>
                                <h6 className="mb-0">AED {Number(stats.monthly_revenue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="solar:wallet-bold" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             {/* Revenue Today */}
             <div className="col">
                <div className="card shadow-none border bg-gradient-start-3 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Revenue Today</p>
                                <h6 className="mb-0">AED {Number(stats.revenue_today).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="solar:dollar-minimalistic-bold" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ControlTowerCards
